import _ from 'lodash';
import {
    FETCH_MTOKNA_SELLER_COMPLAINTS,
    CLEAN_MTOKNA_SELLER_COMPLAINTS,
    CHANGE_MTOKNA_SELLER_COMPLAINT_STATE,
} from './types';
import {request, __} from '../functions';

export const fetchMtoknaSellerComplaints = (screen, options = {}, all = false) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    let uri = '/mtokna/sellerComplaints';

    if (all) {
        uri = '/mtokna/allComplaints';
    }

    return dispatch => request(uri, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_SELLER_COMPLAINTS, payload: data });
    });
};

export const cleanMtoknaSellerComplaints = () => ({ type: CLEAN_MTOKNA_SELLER_COMPLAINTS });

export const changeMtoknaSellerComplaintState = (screen, id, s, data) => {
    return dispatch => request(`/mtokna/changeSellerComplaintStatus/${id}/${s}`, data, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            // Stav sa nepodarilo zmenit
            screen.showSnackbar('error', __('Stav reklamácie sa nepodarilo zmeniť'));
            return;
        }

        screen.showSnackbar('success', __('Stav reklamácie bol zmenený'));

        dispatch({ type: CHANGE_MTOKNA_SELLER_COMPLAINT_STATE, payload: { id, status: s, data } });
    });
};
